import { render, staticRenderFns } from "./DashboardInfo.vue?vue&type=template&id=8a513884&scoped=true&"
import script from "./DashboardInfo.vue?vue&type=script&lang=js&"
export * from "./DashboardInfo.vue?vue&type=script&lang=js&"
import style0 from "./DashboardInfo.vue?vue&type=style&index=0&id=8a513884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a513884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
